// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get, isEmpty, map} from 'lodash';

// Styles
import './element-tree.scss';

class ElementTree extends Component {
    childLineRefs = {};

    childRefs = {};

    componentDidMount() {
        this.updateElementHeights();
    }

    componentDidUpdate() {
        this.updateElementHeights();
    }

    updateElementHeights = () => {
        map(this.childRefs, (element, key) => {
            if (key in this.childLineRefs && this.childLineRefs[key]) {
                this.childLineRefs[key].style.height = `${element.clientHeight / 2}px`;
            }
        });
    };

    setChildRef = (element, childElementName) => {
        this.childRefs[childElementName] = element;
    };

    setChildLineRef = (element, childElementName) => {
        this.childLineRefs[childElementName] = element;
    };

    render() {
        const {childElements, dataTree, elementName, path = [], renderName} = this.props;
        const childrenElements = dataTree
            ? Object.keys(get(dataTree, [...path, elementName], {}))
            : get(childElements, elementName, []);

        return (
            <div className="element-tree">
                <div className="element-tree--text">{renderName(elementName, path)}</div>

                {!isEmpty(childrenElements) ? (
                    <>
                        <div className="element-tree--text-line-cell">
                            <hr className="element-tree--text-line" />
                        </div>

                        <div className="element-tree--children-wrapper">
                            <div className="element-tree--children">
                                {map(childrenElements, (childElementName) => (
                                    <div className="element-tree--child" key={childElementName}>
                                        {childrenElements.length === 1 ? (
                                            <div className="element-tree--text-line-cell">
                                                <hr className="element-tree--text-line" />
                                            </div>
                                        ) : (
                                            <div className="element-tree--line-wrapper">
                                                <div
                                                    className="element-tree--line"
                                                    ref={(childLine) =>
                                                        this.setChildLineRef(childLine, childElementName)}
                                                />{' '}
                                            </div>
                                        )}
                                        <div
                                            className="element-tree--child-element"
                                            ref={(child) => this.setChildRef(child, childElementName)}
                                        >
                                            <ElementTree
                                                {...this.props}
                                                elementName={childElementName}
                                                path={[...path, elementName]}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        );
    }
}

ElementTree.propTypes = {
    childElements: PropTypes.object,
    dataTree: PropTypes.object,
    elementName: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    path: PropTypes.array,
    renderName: PropTypes.func.isRequired,
};

export default ElementTree;
